import {Component} from '@angular/core';
import {NavigationService} from '@app/core';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  constructor(private _navigationService: NavigationService) {
    this._navigationService.startSaveHistory();
  }
}
